import { XIcon } from "@/components/XIcon";

export const ShareOnX = ({ text, url, className = "", label = "Share on X", testid = "share-on-x" }) => {
  const href = `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(href, "_blank", "noopener,noreferrer,width=600,height=520");
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={handleClick}
      className={
        className ||
        "inline-flex items-center gap-2 text-xs uppercase tracking-[0.12em] font-bold text-slate-500 hover:text-[#0A1128] transition-colors duration-200"
      }
    >
      <XIcon className="w-3.5 h-3.5" /> {label}
    </button>
  );
};
